require(["jquery", "root/Assets/Js/Validate", "tooltipster"], function(
	$,
	validate
) {
	//REPLACES BUGGY SHARP S WITH TWO S
	$("#adresse").keyup(function() {
		if (
			$(this)
				.val()
				.indexOf("ß") > -1
		) {
			$(this).val(
				$(this)
					.val()
					.replace("ß", "ss")
			);
		}
	});

	$("#sms_aktiv").change(function() {
		if (this.checked) {
			$("input#sms_nummer").prop("disabled", false);
			$("select#sms_vorwahl").prop("disabled", false);
		} else {
			$("input#sms_nummer").prop("disabled", true);
			$("select#sms_vorwahl").prop("disabled", true);
		}
	});

	validate.validateForm("marktpreise-form");

	$('.frc-captcha-solution').tooltipster({
		trigger: "custom",
		onlyOne: false,
		//timer: 3000,
		side: "top",
		// offsetY: 42,
		// fixedLineage: true,
		// repositionOnScroll: true,
		theme: "custom-tooltipster"
	});

	$(document).on("submit", "#marktpreise-form", function(e) {
		e.preventDefault();

		console.info('#marktpreise-form submit');
		var solution = $('.frc-captcha-solution').val();
		console.info(solution);



		// if (grecaptcha.getResponse() == "") {
        //     $(".g-recaptcha").tooltipster("open");
        //     return;
        // }

		if ( $("#marktpreise-form").valid() && solution !== '.UNFINISHED' && solution !== '' ) {
			$("#marktpreise-form").fadeOut("slow");

			$.ajax({
				type: "POST",
				url:
					"https://remote.steirerfleisch.at/MarktpreisNewsletter/abonnieren.php",
				crossDomain: true,
				data: $("#marktpreise-form").serialize(),
				dataType: "json",
				success: function(res) {
					if(res != 1) {
						$("#marktpreise-form-error").fadeIn("slow");
					} else {
						$("#marktpreise-form-success").fadeIn("slow");
					}

				},
				error: function(res) {
					console.log("ERROR");
					console.log(res);
					$("#marktpreise-form-error").fadeIn("slow");
				}
			});
		}

	}); // on submit
});

define("root/Assets/Templates/Html/MarktpreiseForm/Js/MarktpreiseForm", function(){});

